import styled from "styled-components";

import { flexCenter, rem } from "@styles/Utilities.styled";

import { StyledSurgicalHistoryCard } from "../SurgicalHistoryCard/SurgicalHistoryCard.styled";


export const StyledAllergyCard = styled(StyledSurgicalHistoryCard)`
  .body {
    margin-top: 1.5rem;
  }

  .tags-wrapper {
    display: flex;
    flex-flow: row wrap;
    gap: 0.5rem;
  }

  .allergies-left {
    ${flexCenter}
    font-size: ${rem(13)};
    /* outline: 1px solid red; */
  }
`;
